import axios from 'axios'
import { CREATE_BUILDING } from './types'

const createBuilding = (building) => async (dispatch, getState) => {
  const user = getState().auth
  const buildingCreated = await axios.post('/api/buildings/create', {
    building,
    user,
  })
  dispatch({
    type: CREATE_BUILDING,
    payload: buildingCreated,
  })
}
export default createBuilding
